// @ts-nocheck
import { useState } from 'react';
import { YStack, XStack, Text } from 'tamagui';
import { Plus, Minus } from '@phosphor-icons/react';
import { GridBand } from './GridBand';
import { useIsMobile } from '../hooks/useIsMobile';

/**
 * Objection handling.
 *
 * These are the four things a serious visitor actually thinks and does not ask.
 * The continuity question in particular — what happens if the founder stops —
 * is the first doubt about a one-person company and the last thing most
 * one-person companies address. Answering it unprompted converts the obvious
 * weakness into evidence the risk has been thought through.
 */
const questions = [
  {
    q: 'Why eight products instead of one?',
    a: 'Because the expensive part is shared. Identity, billing, organizations, and permissions are the same problem every time — solved once, every new product starts at the feature layer. The products are independent and sell separately; only the foundation is common.',
  },
  {
    q: 'Is this a company or a side project?',
    a: 'A cashflow business, deliberately. No fundraising and no blitzscaling — products that pay for themselves. Torch and Statio run in production on the shared platform today, and four of the projects are open source under Apache 2.0.',
  },
  {
    q: 'What happens if you stop working on this?',
    a: 'The fair version of that question is about continuity, and it deserves a real answer rather than reassurance. Source escrow is available on enterprise agreements, every product has a documented data-export path, and nothing is stored in a proprietary format. Your data leaves whenever you want it to.',
  },
  {
    q: 'Why the Roman names?',
    a: 'A Classical Antiquities minor and a habit. Statio was the guarded checkpoint on a Roman road; Janus saw both directions at once; a denarius was the coin; scuta were the shields; a capsa held the scrolls. The names are load-bearing more often than not.',
  },
];

export function FAQ() {
  const isMobile = useIsMobile();
  const [open, setOpen] = useState(null);

  return (
    <GridBand eyebrow="Questions" title="Reasonable things to ask." split tint>
      <YStack borderTopWidth={1} borderColor="$color3">
              {questions.map((item, i) => {
                const isOpen = open === i;

                return (
                  <YStack
                    key={item.q}
                    borderBottomWidth={1}
                    borderColor="$color3"
                  >
                    <XStack
                      paddingVertical={isMobile ? '$4' : '$5'}
                      justifyContent="space-between"
                      alignItems="center"
                      gap="$4"
                      cursor="pointer"
                      hoverStyle={{ opacity: 0.82 }}
                      onPress={() => setOpen(isOpen ? null : i)}
                    >
                      <Text
                        fontSize={isMobile ? '$5' : '$6'}
                        fontWeight="500"
                        color="$color11"
                        flex={1}
                      >
                        {item.q}
                      </Text>
                      {isOpen ? (
                        <Minus size={18} color="var(--amber7)" />
                      ) : (
                        <Plus size={18} color="var(--amber7)" />
                      )}
                    </XStack>

                    {isOpen && (
                      <Text
                        fontSize="$4"
                        color="$color8"
                        lineHeight={24}
                        paddingBottom={isMobile ? '$4' : '$5'}
                        maxWidth={660}
                      >
                        {item.a}
                      </Text>
                    )}
                  </YStack>
                );
              })}
      </YStack>
    </GridBand>
  );
}
